// Legacy URL -> current page map (from GSC cleanup). Keys are paths WITHOUT trailing slash.
// Applied client-side by LegacyRedirect because the static edge does not honour _redirects.
export const LEGACY_REDIRECTS = {
  // Solihull consolidation (26 Oct 2026, approved by Paul): one principal
  // Solihull page. The bookkeeping combo earned 36 impressions at position 41.3
  // against the general page's 1,378 at 35.0, and overlapped its purpose; its
  // local copy and one FAQ were merged into the general page before this went in.
  "/bookkeeping-services-solihull": "/accountants-solihull",
  // Pricing consolidation (28 Sep 2026): the journey now lives at /pricing, the
  // original and stronger URL, so the builder's own URL consolidates into it.
  "/build-your-package": "/pricing",
  // Added 31 Aug 2026 from Search Console data: old URLs still earning
  // impressions (and in one case clicks) that had no rule and were soft-404ing.
  "/cloud-accounting-support-services-for-health-and-social-care": "/services",
  "/cloud-accounting-support-services-for-ecommerce-companies": "/services",
  "/meeting-room-hire-tamworth": "/meeting-room-hire",
  "/trouble-shooting": "/services/troubleshooting",
  "/vat-2": "/services/vat",
  "/4-important-questions-to-ask-if-youre-looking-for-cloud-accounting-support": "/blog",
  "/how-small-accountancy-firms-can-grow-profits-with-cloud-based-payroll": "/services/payroll",
  "/cass-celebrates-double-finalist-recognition-at-the-2025-luca-awards": "/blog",
  "/smart-finance-for-fast-growth-our-highlights-from-the-festival-of-entrepreneurs": "/blog",
  "/celebrating-giving-back-casss-contributions-to-two-rivers-primary-schools-garden": "/blog",
  "/blog/bookkeeping-mistakes-to-avoid": "/blog",
  "/blog/why-move-to-xero-cloud-accounting": "/blog",
  "/blog/budget-implications-for-smes": "/blog",
  "/migrating-from-your-current-accounting-software": "/services/set-up-and-implementation",
  "/pauls-biography": "/team",
  "/20-off-xero": "/services/xero-subscription",
  "/Cass_online_ltd": "/services",
  "/a-heartfelt-farewell-to-annie-celebrating-a-pillar-of-our-cloud-accounting-support-services-team": "/blog",
  "/celebrating-": "/blog",
  "/about-us": "/about",
  "/about-us/Cass_online_ltd": "/about",
  "/are-you-currently-using-sage-line-50-accounting-software": "/services/set-up-and-implementation",
  "/author/ali": "/team",
  "/author/cass": "/team",
  "/author/hannah": "/team",
  "/axe-throwing-adventure-cloud-accounting-supports-unforgettable-team-building-event": "/blog",
  "/beyond-the-numbers": "/more-than-numbers/business-assessment-tools",
  "/bookkeeping": "/services/bookkeeping",
  "/bookkeeping/Cass_online_ltd": "/services/bookkeeping",
  "/bookkeeping/facebook.com/cloudaccountingsupportservices": "/services/bookkeeping",
  // Explicit single-step rules for the WordPress archives Search Console
  // reported (17 Jun 2026). The /category/* pattern already covered them in
  // the SPA, but the edge list needs the exact source URL to emit one 301.
  "/category/bookkeeping": "/blog",
  "/category/news": "/blog",
  "/clean-up-and-fixing-errors": "/services/troubleshooting",
  "/clean-up-and-fixing-errors/Cass_online_ltd": "/services/troubleshooting",
  "/clean-up-and-fixing-errors/facebook.com/cloudaccountingsupportservices": "/services/troubleshooting",
  "/cloud-accounting-subscription": "/services/xero-subscription",
  "/cloud-accounting-support-services-and-local-businesses-recognised-in-prestigious-awards": "/blog",
  "/cloud-accounting-support-services-are-now-xero-platinum-partners": "/blog",
  "/cloud-accounting-support-services-cass-commits-to-year-round-free-support-for-smes-following-successful-finance-webinar": "/blog",
  "/cloud-accounting-support-services-cass-thanks-staff-with-half-day-leave-for-employee-appreciation-day": "/blog",
  "/cloud-accounting-support-services-celebrates-major-growth-with-expanded-offices-and-new-business-hub-for-tamworth": "/blog",
  "/cloud-accounting-support-services-for-construction": "/services",
  "/cloud-accounting-support-services-for-farming": "/services",
  "/cloud-accounting-support-services-for-football-clubs": "/services",
  "/cloud-accounting-support-services-for-hospitality": "/services",
  "/cloud-accounting-support-services-for-manufacturing": "/services",
  "/cloud-accounting-support-services-for-non-profits-and-charities": "/services",
  "/cloud-accounting-support-services-for-real-estate-and-estate-agents": "/services",
  "/cloud-accounting-support-services-for-retail-companies": "/services",
  "/cloud-accounting-support-services-for-trade": "/services",
  "/cloud-accounting-support-services-for-trade/Cass_online_ltd": "/services",
  "/cloud-accounting-support-services-for-trade/facebook.com/cloudaccountingsupportservices": "/services",
  "/cloud-accounting-support-services-making-a-difference-at-the-pimp-my-ride-vip-launch": "/blog",
  "/cracking-the-code-unlocking-payroll-and-payments": "/blog",
  "/from-spreadsheets-to-spotlights-how-cass-helped-light-up-the-night-for-cancer-research": "/blog",
  "/getting-a-virtual-finance-department-the-benefits": "/services/outsourced-finance",
  "/interview-with-adrian-kibbler": "/blog",
  "/legal-cashiering/Cass_online_ltd": "/services",
  "/legal-cashiering/case-study/Cass_online_ltd": "/services",
  "/legal-cashiering/facebook.com/cloudaccountingsupportservices": "/services",
  "/limited-company-year-end": "/services/ltd-co-accounts",
  "/maximising-your-financial-wellness-a-guide-to-tech-prep-for-your-year-end-self-assessment-and-for-the-new-tax-year": "/blog",
  "/migration-2": "/services/set-up-and-implementation",
  "/mtd-for-it": "/making-tax-digital-income-tax",
  "/services/mtd-for-it": "/making-tax-digital-income-tax",
  "/mtd-for-itsa-the-landlords-guide": "/making-tax-digital-income-tax",
  "/new-year-new-financial-clarity-cleaning-up-your-xero-for-business-success": "/blog",
  "/newsletter-archive": "/blog",
  "/on-going-software-support": "/services/support",
  "/payroll-2": "/services/payroll",
  "/podcast-links": "/podcast",
  "/podcast-links/Cass_online_ltd": "/podcast",
  "/podcast-links/facebook.com/cloudaccountingsupportservices": "/podcast",
  "/podcast-season-1": "/podcast",
  "/podcast-season-2": "/podcast",
  "/power-huddle": "/services",
  "/request-a-call-back": "/contact",
  "/request-a-call-back/Cass_online_ltd": "/contact",
  "/request-a-call-back/facebook.com/cloudaccountingsupportservices": "/contact",
  "/self-assessment-2": "/services/self-assessment",
  "/self-assessment-2/Cass_online_ltd": "/services/self-assessment",
  "/service-template": "/services",
  "/service-template/Cass_online_ltd": "/services",
  "/set-up-and-implementation": "/services/set-up-and-implementation",
  "/set-up-and-implementation-support": "/services/set-up-and-implementation",
  "/sign-up": "/contact",
  "/software": "/services",
  "/software-training": "/services/support",
  "/xero-training": "/services/support",
  "/software/Cass_online_ltd": "/services",
  "/support-2": "/services/support",
  "/tag/accountant-tamworth": "/blog",
  "/tag/accounting-tamworth": "/blog",
  "/tag/bookkeeper-tamworth": "/blog",
  "/tag/citrus-hr": "/blog",
  "/tag/cloud-accounting-software-support": "/blog",
  "/tag/cloud-accounting-support-services": "/blog",
  "/tag/sage-accounting-software": "/blog",
  "/tag/sage-line-50": "/blog",
  "/tag/tamworth-business": "/blog",
  "/tag/tamworth-small-business-of-the-year": "/blog",
  "/tag/xero-software": "/blog",
  "/tamworth-academy-fc-11s-away-shirt-sponsor": "/blog",
  "/tamworth-based-firm-recognised-nationally-by-xero-with-double-award-nomination": "/blog",
  "/tamworth-boxing-club": "/blog",
  "/tax-planning-2": "/services/tax-planning",
  "/team-cass-launches-inspiring-new-podcast-giving-you-more-than-numbers": "/blog",
  "/team-cass-launches-season-2-of-its-sme-growth-podcast": "/blog",
  "/thank-you": "/contact",
  "/training-2": "/services/support",
  "/services/training": "/services/support",
  "/trusted-partners": "/about",
  "/what-accounting-technology-is-out-there": "/services",
  "/what-are-the-basic-principles-of-bookkeeping": "/services/bookkeeping",
  "/what-are-the-basic-principles-of-bookkeeping/Cass_online_ltd": "/services/bookkeeping",
  "/what-are-the-basic-principles-of-bookkeeping/facebook.com/cloudaccountingsupportservices": "/services/bookkeeping",
  "/what-we-do": "/services",
  "/who-we-help": "/services",
  "/work-at-cass": "/careers",
  "/worth-unlimited-charity": "/blog",
  "/xero-subscription": "/services/xero-subscription",
  "/xero-subscription/Cass_online_ltd": "/services/xero-subscription",
  "/xero-subscription/facebook.com/cloudaccountingsupportservices": "/services/xero-subscription",
  // Duplicate Ask Cassie answers retired onto the version that was kept (26 Oct 2026).
  "/ask-cassie/do-i-need-to-be-on-xero-2": "/ask-cassie/management-accounts?a=do-i-need-to-be-on-xero",
  "/ask-cassie/how-often-will-my-bookkeeping-be-updated-2": "/ask-cassie/bookkeeping-xero?a=how-often-will-my-bookkeeping-be-updated",
  "/ask-cassie/can-you-run-payroll-for-just-one-employee": "/ask-cassie/payroll-pensions?a=can-you-run-payroll-for-one-employee",
  "/ask-cassie/can-you-manage-workplace-pensions-2": "/ask-cassie/payroll-pensions?a=can-you-manage-workplace-pensions",
  "/ask-cassie/can-you-work-with-my-existing-accountant-2": "/ask-cassie/working-with-cass?a=can-you-work-with-my-existing-accountant",
};
